import { Form, Input, Button, Alert, Tooltip } from 'antd';
import { UserOutlined, LockOutlined, MobileOutlined } from '@ant-design/icons';
import '../index.css';
import './style.css';
import { IResult } from '../../components/infrastructure/models';
import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Core } from '../../components/infrastructure/core';
import { Captcha } from '../../components/captcha/index';
import { Timer } from '../forgetPassword/timer';
import AppContext from '../../components/infrastructure/appContext';

interface IPolicyholderLoginState {
    success?: boolean;
    loading?: boolean;
    codeSent?: boolean;
    forceCaptcha: boolean;
    captcha?: string;
    firstSendCode?: boolean;
}

interface IPolicyholderLoginProp {
    userName?: string;
    phone?: string;
    phoneNotDefined?: boolean;
    onReturn?: () => void;
    captcha: string;
    lastSendCode?: number;
}

const PolicyholderLogin = (props: IPolicyholderLoginProp) => {
    const [state, setState] = React.useState<IPolicyholderLoginState>({ success: false, forceCaptcha: !props.captcha, captcha: props.captcha, firstSendCode: true, codeSent: !!props.lastSendCode });
    const [form] = Form.useForm();
    const { params } = React.useContext(AppContext);

    const componentWillUnmount = React.useRef(false);
    const submitKind = React.useRef<'login' | 'sendcode' | undefined>();

    const onPasswordValidate = () => {
        if (submitKind.current === 'login' && !form.getFieldValue('password'))
            return Promise.reject(new Error('لطفا کلمه عبور را وارد نمایید'));
        return Promise.resolve();
    }

    const onNationalCodeValidate = () => {
        const nationalCode = form.getFieldValue('nationalCode');
        if (!!nationalCode && !Core.isNationalCode(nationalCode))
            return Promise.reject(new Error('کد ملی میبایست معتبر باشد'));
        return Promise.resolve();
    }

    const onTimerExpired = () => setState({ forceCaptcha: true });

    const onLogin = () => submitKind.current = 'login';

    const onSendCode = () => {
        if (state.codeSent)
            return;
        submitKind.current = 'sendcode';
        form.submit();
    }

    const login = async (values: any) => {

        setState({ ...state, loading: true, codeSent: state.codeSent, forceCaptcha: false, captcha: values['captcha'] ?? state.captcha });
        let response = await fetch("api/userpolicyholder/login", {
            method: 'POST',
            body: JSON.stringify({
                userName: props.userName,
                password: values['password'],
                captcha: values['captcha'] ?? state.captcha,
                rememberMe: false //values['remember']
            }),
            headers: { 'content-type': 'application/json;charset=UTF-8' }
        });

        if (componentWillUnmount.current)
            return;

        if (response.status === 200) {
            let result: IResult = await response.json();
            if (!result.ValidationState.Successful) {
                Core.errorNotification(result.ValidationState.ValidationResults[0].Message);
                setState({ loading: false, forceCaptcha: true, firstSendCode: state.firstSendCode, codeSent: state.codeSent });
            }
            else {
                Core.successNotification('خوش آمدید');
                setState({ success: true, forceCaptcha: false });
            }
        }
        else {
            setState({ loading: false, forceCaptcha: true, firstSendCode: state.firstSendCode, codeSent: state.codeSent });
        }
    };

    const sendCode = async (values: any) => {

        setState({ loading: true, codeSent: false, forceCaptcha: false, captcha: values['captcha'] ?? state.captcha })
        let response = await fetch("api/userpolicyholder/sendcode", {
            method: 'POST',
            body: JSON.stringify({
                userName: values['nationalCode'],
                captcha: values['captcha'] ?? state.captcha
            }),
            headers: { 'content-type': 'application/json;charset=UTF-8' }
        });

        if (componentWillUnmount.current)
            return;

        if (response.status === 200) {
            let result: IResult = await response.json();
            if (!result.ValidationState.Successful) {
                Core.errorNotification(result.ValidationState.ValidationResults[0].Message);
                setState({ loading: false, forceCaptcha: true, firstSendCode: state.firstSendCode, codeSent: state.codeSent });
            }
            else {
                Core.successNotification('کلمه عبور یکبار مصرف با موفقیت ارسال شد');
                setState({ loading: false, codeSent: true, forceCaptcha: false, firstSendCode: false, captcha: values['captcha'] ?? state.captcha });
            }
        }
        else {
            setState({ loading: false, forceCaptcha: true, firstSendCode: state.firstSendCode, codeSent: state.codeSent });
        }
    };

    const onFinish = (values: any) => {
        if (state.loading)
            return;

        if (submitKind.current === 'login')
            login(values);
        else if (submitKind.current === 'sendcode')
            sendCode(values);
    }

    const phoneNotDefined = props.phoneNotDefined || params['phonenotdefined'] === "true";
    const phone = phoneNotDefined && !!props.userName ? "شماره تلفن ثبت نشده است" : props.phone;

    React.useEffect(() => {
        return () => {
            componentWillUnmount.current = true;
        };
    }, []);

    if (state.success) {
        let returnUrl = '/';
        if (params["returnurl"] && params["returnurl"] !== '/logout')
            returnUrl = decodeURIComponent(params["returnurl"]);
        const split = returnUrl.split('?');
        return <Redirect to={{ pathname: split[0], search: split.length > 1 ? '?' + split[1] : '' }} />
    }

    const disableLoginBtn = state.codeSent !== true && Core.isDevelopement !== true;

    return (
        <>
            <div className="box box-blue" style={{ border: "1px solid white", borderTopLeftRadius: 15, borderTopRightRadius: 15 }}>
                <img src={'/userlogo.png'} style={{ marginTop: 20, width: 80 }} alt="" />
                <p className="" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', fontSize: 18, fontWeight: "bold", color: "antiquewhite" }}>
                    <>ورود بیمه گزار/مشتری</>
                </p>
            </div>

            <Form
                form={form}
                //labelCol={{ span: 6 }}
                wrapperCol={{ span: 24 }}
                name="normal_login"
                className="box login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onReset={() => {
                    if (props.onReturn)
                        props.onReturn();
                    else
                        setState({ loading: false, forceCaptcha: true });
                }}
                style={{ paddingLeft: 50, paddingRight: 50, paddingBottom: 50, paddingTop: 5, border: "1px solid white", backgroundColor: "#fefefe90", borderBottomLeftRadius: 15, borderBottomRightRadius: 15, width: "100%", textAlign: "right" }}
            >
                <Form.Item
                    name="nationalCode"
                    //label="کد ملی"
                    initialValue={props.userName ?? ''}
                    rules={[{ validator: onNationalCodeValidate }]}
                    hidden
                >
                    <Input
                        autoComplete="off"
                        prefix={<UserOutlined className="site-form-item-icon" />}
                        placeholder="کد ملی" disabled={!!props.phone && props.phone !== ""}
                    />
                </Form.Item>

                <Form.Item
                    //label="موبایل"
                    hidden
                >
                    <Input disabled value={phone} suffix={<MobileOutlined className="site-form-item-icon" />} style={{ direction: 'ltr', display: 'inline-flex' }} />
                </Form.Item>

                <Alert
                    style={{ marginTop: 10, marginBottom: 20, textAlign: 'justify' }}
                    message={
                        state.codeSent ?
                            <div>
                                بیمه گزار/مشتری گرامی، کلمه عبور یکبار مصرف به شماره
                                &nbsp;
                                <b style={{ unicodeBidi: "plaintext" }}>{props.phone}</b>
                                &nbsp;
                                ارسال شد،
                                پس از دریافت پیامک، کد دریافت شده را در باکس پایین وارد نمایید.
                            </div>
                            :
                            <>
                                {phoneNotDefined ?
                                    <div>
                                        بیمه گزار/مشتری گرامی، شماره موبایل ثبت نشده است،
                                        لطفا از
                                        &nbsp;
                                        <Link className="login-form-forgot" to={{ pathname: '/changecontact', search: '?username=' + props.userName + '&phone=' + props.phone }}>
                                            <Tooltip title="ویرایش شماره موبایل">
                                                <b style={{ borderBottom: "1px solid", paddingBottom: 2 }} >اینجا</b>
                                            </Tooltip>
                                        </Link>
                                        &nbsp;
                                        شماره موبایل خود را ثبت نمایید.
                                    </div>
                                    :
                                    <div>
                                        بیمه گزار/مشتری گرامی، کلمه عبور یکبار مصرف به شماره
                                        &nbsp;
                                        <b style={{ unicodeBidi: "plaintext" }}>{props.phone}</b>
                                        &nbsp;
                                        ارسال خواهد شد،
                                        لطفا در صورتی که شماره همراه شما تغییر کرده است، از
                                        &nbsp;
                                        <Link className="login-form-forgot" to={{ pathname: '/changecontact', search: '?username=' + props.userName + '&phone=' + props.phone }}>
                                            <Tooltip title="ویرایش شماره موبایل">
                                                <b style={{ borderBottom: "1px solid", paddingBottom: 2 }} >اینجا</b>
                                            </Tooltip>
                                        </Link>
                                        &nbsp;
                                        شماره موبایل خود را ویرایش نمایید.
                                    </div>
                                }
                            </>
                    }
                    type="info"
                />

                <Form.Item
                    name="password"
                    //label="کلمه عبور"
                    rules={[{ validator: onPasswordValidate }]}
                >
                    <Input
                        autoComplete="off"
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        placeholder="کلمه عبور یکبار مصرف"
                        type="password"
                    />
                </Form.Item>

                {state.forceCaptcha &&
                    <Captcha
                        form={form}
                        name="captcha"
                        label="متن تصویر"
                    />
                }

                {/*{state.codeSent &&*/}
                {/*    <Form.Item*/}
                {/*        name="remember"*/}
                {/*        valuePropName="checked"*/}
                {/*        style={{ textAlign: 'right', marginTop: 15, marginBottom: 15 }}*/}
                {/*    >*/}
                {/*        <Checkbox>*/}
                {/*            <span>به خاطر بسپار</span>*/}
                {/*        </Checkbox>*/}
                {/*    </Form.Item>*/}
                {/*}*/}

                <Form.Item
                    style={{ direction: 'ltr', textAlign: 'justify' }}
                >
                    <>
                        {!phoneNotDefined &&
                            <Button
                                htmlType="button"
                                type="primary"
                                className="login-form-button"
                                loading={state.loading}
                                onClick={onSendCode}
                                style={{ pointerEvents: state.codeSent ? 'none' : 'inherit', opacity: state.codeSent ? 0.6 : 0.9, backgroundColor: '#4ca066', }}
                            >
                                {state.codeSent && <Timer key="timer" estimationTime={{ minutes: !!props.lastSendCode ? Math.floor(props.lastSendCode / 60) : 3, seconds: !!props.lastSendCode ? props.lastSendCode % 60 : 0 }} expired={onTimerExpired} />}
                                {state.loading === true
                                    ? (submitKind.current === 'sendcode' ? <>درحال ارسال کلمه عبور</> : (state.codeSent ? <>ارسال مجدد</> : <> درحال بررسی کلمه عبور</>))
                                    : (state.firstSendCode === true ? <>ارسال کلمه عبور</> : (state.codeSent ? <>ارسال مجدد</> : <>ارسال مجدد کلمه عبور</>))
                                }
                            </Button>
                        }
                        <Button type="primary" htmlType="submit" disabled={disableLoginBtn} onClick={onLogin} className="login-form-button" loading={state.loading}>
                            <span>
                                ورود
                            </span>
                        </Button>

                        <Button type="default" htmlType="reset" className="login-form-button" loading={state.loading}>
                            انصراف
                        </Button>
                    </>
                </Form.Item>
            </Form>
        </>
    );
};

export default PolicyholderLogin;